import { render } from "./OnboardPageV2.vue?vue&type=template&id=72aea8b7&scoped=true"
import script from "./OnboardPageV2.vue?vue&type=script&lang=js"
export * from "./OnboardPageV2.vue?vue&type=script&lang=js"

import "./OnboardPageV2.vue?vue&type=style&index=0&id=72aea8b7&scoped=true&lang=scss"
import "./OnboardPageV2.vue?vue&type=style&index=1&id=72aea8b7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72aea8b7"]])

export default __exports__